import {
  capitalize,
  Card,
  CardContent,
  lighten,
  Stack,
  Typography,
} from "@mui/material";
import { endOfDay, parseISO } from "date-fns";
import { AlarmIcon } from "@/components/common/icons";
import IconCircleContainer from "@/components/common/icons/containers/iconCircleContainer";
import StyledCircleOverlay from "@/components/common/styledCircleOverlay/styledCircleOverlay";
import { WHITE } from "@/config/mui/colorPalette";
import { getTimeDifferenceString } from "@/utils/date";

type Props = {
  primaryColor: string;
  endDate: string;
};

export default function FeaturedDealsPromoCard({
  primaryColor,
  endDate,
}: Props) {
  return (
    <Card
      variant="outlined"
      sx={{
        height: "100%",
        position: "relative",
        backgroundColor: lighten(primaryColor, 0.9),
        borderColor: lighten(primaryColor, 0.8),
      }}
    >
      <CardContent
        sx={{
          display: "flex",
          boxSizing: "border-box",
          height: "100%",
          flexDirection: "column",
        }}
      >
        <IconCircleContainer
          icon={<AlarmIcon size="36px" color={primaryColor} set="duotone" />}
          color={WHITE}
          size="64px"
        />
        <Stack
          spacing={1}
          sx={{
            m: "auto",
          }}
        >
          <Typography variant="h3">Check out our special deals</Typography>
          <Typography
            sx={{
              color: "text.secondary",
            }}
          >
            Exclusive deals waiting for you! Don’t miss your chance - limited
            time only!
          </Typography>
        </Stack>

        <Stack
          spacing={0.5}
          sx={{
            color: primaryColor,
          }}
        >
          <Typography
            component="span"
            sx={{
              fontWeight: 800,
              fontSize: "1.875rem",
              lineHeight: "36px",
            }}
          >
            {capitalize(
              getTimeDifferenceString(endOfDay(parseISO(endDate)), new Date())
            )}{" "}
            left
          </Typography>
          <Typography variant="labelSmall">to grab a deal</Typography>
        </Stack>
        <StyledCircleOverlay color={primaryColor} />
      </CardContent>
    </Card>
  );
}
